export default __webpack_public_path__ + "static/media/UserGuide_el_GR.600f1a0b.pdf";